var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NovaLocalizacao.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-12e03bf2\",\"hasScoped\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NovaLocalizacao.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/policia-civil/processo/localizacao/components/NovaLocalizacao.vue
// module id = 1222
// module chunks = 17